import React, { useState, useEffect } from 'react';
import taxi from './belfast-cab-tour-contact.png';
import '../Styles.css';

const ContactUs = () => {
  // State to store the current scroll position
  const [scrollTop, setScrollTop] = useState(0);

  // Set up a scroll event listener to track scroll position
  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY); // Get the scroll position
    };

    window.addEventListener('scroll', handleScroll); // Add event listener
    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up on component unmount
    };
  }, []);

  return (
    <div
      id="contact-us-page"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      {/* Header */}
      <header className="ContactUs-header">
        <div className="animation-wrapper">
          <img
            src={taxi}
            className="taxi"
            alt="taxi"
            style={{
              top: '-2%', // Adjust this value to raise the taxi
              transform: `translateY(-${scrollTop / 100}%)`, // Dynamic scroll effect
            }}
          />
        </div>
      </header>

      {/* Main Content */}
      <h1 className="ContactUs-header1" style={{ textAlign: 'center', marginBottom: 0 }}>
        <a href="tel:+447773600624" className="call-us-button">
          <i className="fas fa-phone-alt"></i> Call us +447773600624
        </a>
        <br />
        <a
          href="https://wa.me/+447773600624?text=Hello%2C%20I%20need%20more%20info"
          target="blank"
          className="whatsapp-button"
        >
          <i className="fab fa-whatsapp"></i> Click to message us on WhatsApp!
        </a>
      </h1>

      {/* Footer */}
      <footer
        style={{
          textAlign: 'center',
          padding: '1rem',
          backgroundColor: '#333',
          color: '#fff',
          marginTop: 'auto', // Push the footer to the bottom
        }}
      >
        &copy; 2025{' '}
        <a
          href="https://belfastcabtour.com"
          style={{ color: '#fff', textDecoration: 'none' }}
        >
          belfastcabtour.com
        </a>
        . All rights reserved.
      </footer>
    </div>
  );
};

export default ContactUs;
